export default "__VITE_ASSET__Cvx9VGs3__"